<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-geographical.svg" can-back-flag="1"></Header>
    </header>

    <!--一覧-->
    <div id="wrapper">
      <div class="content">
        <div class="geographical-list-box">
          <h3 class="ttl">【テーマ・掲載地域】</h3>
          <article v-for='row in rows' v-bind:key='row.id'>
            <div class="box-l">
              <h4 class="subttl" v-html="row.title"></h4>
              <p v-html="row.area"></p>
            </div>
            <div class="box-r">
              <ul>
                <li><a :href="row.url" target="_blank" rel="noopener">地理院地図 →</a></li>
                <li><a href="#" :data-id="row.id" v-on:click.prevent='linkAction'>解説 →</a></li>
              </ul>
            </div>
          </article>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-geographical")
    $("body").addClass("page-geographical-index")
    cmd.adjustStyle()

    this.search()
  },
  methods: {
    ...mapActions('GeographModule', {
      'prevAction': 'prevAction',
      'search': 'search',
      'showDetail': 'showDetail',
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('data-id')
      this.showDetail(id)
    }

  },
  computed: {
    ...mapGetters('GeographModule', [
      'rows'
    ])
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GeographList.vue